import { render, staticRenderFns } from "./GovernanceDataTable.vue?vue&type=template&id=44602bbf"
import script from "./GovernanceDataTable.vue?vue&type=script&lang=js"
export * from "./GovernanceDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports